<template>
	<div
		class="flex size-full flex-col items-center justify-center"
		:class="`mt-[${topMarginInPx}px]`"
	>
		<svg
			stroke="#2A8176"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			:style="{width: `${sizeInPx}px`, height: 'auto'}"
		>
			<g class="loading-spinner">
				<circle
					cx="12"
					cy="12"
					r="9.5"
					fill="none"
					:stroke-width="strokeWidth"
				/>
			</g>
		</svg>
        
		<span
			v-if="showLoadingText"
			class="mt-6 text-won-dark-blue"
			:class="textClasses"
		>
			{{ text }}
		</span>
	</div>
</template>

<script setup>
defineProps({
	text: {
		type: String,
		default: 'Loading...',
	},
	sizeInPx: {
		type: Number,
		default: 80
	},
	textClasses: {
		type: String,
		default: 'text-[20px] font-medium leading-7'
	},
	strokeWidth: {
		type: Number,
		default: 3
	},
	showLoadingText: {
		type: Boolean,
		default: true
	},
	topMarginInPx: {
		type: Number,
		default: 121
	}
});
</script>

<style scoped>
.loading-spinner {
    transform-origin: center;
    animation: svg_spin 2s linear infinite
}

.loading-spinner circle {
    stroke-linecap: round;
    animation: circle_spin 1.5s ease-in-out infinite;
}

@keyframes svg_spin {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes circle_spin {
    0% {
        stroke-dasharray: 0 150;
        stroke-dashoffset: 0;
    }
    47.5% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -16;
    }
    95%, 100% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -59;
    }
}
</style>
